import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { UserRootModule } from './pages/user/user-root.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginModule } from './pages/login-pages/login.module';
import { PipesModule } from './pipes/pipes.module';
import { FragmentsModule } from './fragments/fragments.module';
import { AdministrationModule } from './pages/administration/administration.module';
import { RequestInterceptor } from './services/interceptor/request.interceptor';
import { DecodeHtmlResponseInterceptor } from './services/interceptor/decode-html-response.interceptor';
import { dmpServiceProvider } from './services/dmp/dmp-service.factory';
import { insServiceProvider } from './services/ins/ins-service.factory';
import { cpxHandleServiceProvider } from './services/cpx-handle/cpx-handle-service.factory';
import { MSSErrorInterceptor } from './services/mss/mss-error.interceptor';
import { AboutModule } from './pages/user/about/about.module';
import { ePrescriptionProvider } from './services/ordonnance-numerique/ordonnance-numerique.service';
import { dinnoSessionProvider } from './services/cpx-handle/cpx-handle.service';
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    UserRootModule,
    BrowserAnimationsModule,
    LoginModule,
    PipesModule,
    FragmentsModule,
    AdministrationModule,
    AboutModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DecodeHtmlResponseInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: MSSErrorInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    dmpServiceProvider,
    insServiceProvider,
    cpxHandleServiceProvider,
    ePrescriptionProvider,
    dinnoSessionProvider,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
